import { Box, Flex, Link, Text } from '@chakra-ui/react';
import { Link as CustomLink } from 'components/base/Link';
import { ImageWrapper } from 'components/wrapper/imageWrapper';
import { LinkType } from 'lib/enums/LinkType';
import { Contact } from 'models';
import { withTranslations } from 'store/translations';

const Person = ({
  frontifyImage,
  msImage,
  department,
  displayName,
  hasContact = false,
  id,
  jobTitle,
  city,
  phoneNumber,
}: Omit<Contact['elements'], 'key'> & { hasContact: boolean }) => {
  const { common, multiple, url } = withTranslations();

  return (
    <Flex
      flexDirection='column'
      color='mountain.base'
      justifyContent='space-between'
      alignItems={{ base: 'center', md: 'flex-start' }}
      textAlign={{ base: 'center', md: 'left' }}
    >
      <Box order={0}>
        <ImageWrapper
          alt={displayName.value}
          imageFrontify={frontifyImage.value}
          msImage={msImage.value}
          imageSx={{
            mb: { base: 'xs', lg: 's' },
            w: { base: '160px', lg: '200px' },
            h: { base: '160px', lg: '200px' },
          }}
        />
      </Box>
      <Box>
        <Text as='h3' mb={{ base: 'xxs', lg: '0' }} textStyle='desktop.body.medium.l'>
          {displayName.value}
        </Text>
        <Text textStyle='desktop.body.l'>{jobTitle.value}</Text>
        <Text mb='xs' textStyle='desktop.body.l'>
          {department.value
            .replace(/\b\d{4,}\b/g, '')
            .replace(/^\s+/, '')
            .replace(/^[ -]+|[ -]+$/g, '')}
        </Text>
      </Box>
      <Box>
        {phoneNumber.value && (
          <Link display='block' href={`tel:${phoneNumber.value}`} textStyle='desktop.body.s'>
            {phoneNumber.value}
          </Link>
        )}
        <Text mb='xs' textStyle='desktop.body.l'>
          {city.value}
        </Text>
      </Box>
      {/* TODO: Not implemented at the moment, we will need to figure out how would this work in the future */}
      {/* <Text mb={{ base: 's', lg: 'xs' }} textStyle='desktop.body.s'>
        Local time: {person.localTime}
      </Text> */}
      {hasContact && (
        <Box mt={{ base: 's', lg: 'xs' }}>
          <CustomLink
            href={`/${multiple('contactUsUrl')}/${url('peopleUrl')}/${id.value}`}
            iconName='chevronRightForLink'
            type={LinkType.SecondaryButton}
          >
            {common('getInTouch')}
          </CustomLink>
        </Box>
      )}
    </Flex>
  );
};

export default Person;
